// import React, { useState, useRef, useEffect } from "react";
// import {
//   Paper,
//   NavLink,
//   DataTable,
//   LinearProgress,
//   TertiaryButton,
//   Text,
// } from "../../components";
// import { Alert, AlertTitle } from "@material-ui/lab";
// import { makeStyles } from "@material-ui/styles";
// import BulkActionModule from "./BulkActionModule";
// import executionsStyles from "./executionsStyles";
// import sharedStyles, { dataTableStyles } from "../styles";
// import { Tooltip } from "@material-ui/core";
// import _ from "lodash";

// const useStyles = makeStyles({
//   ...executionsStyles,
//   ...sharedStyles,
// });

// const executionFields = [
//   {
//     name: "startTime",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     type: "date",
//     label: (
//       <Tooltip title="Start Time">
//         <div>Start Time</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "workflowId",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Workflow ID">
//         <div>Workflow ID</div>
//       </Tooltip>
//     ),
//     renderer: (workflowId) => (
//       <Tooltip title={workflowId}>
//         <NavLink path={`/execution/${workflowId}`}>{workflowId}</NavLink>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "workflowType",
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Workflow Type">
//         <div>Workflow Type</div>
//       </Tooltip>
//     ),
//     renderer: (val) => (
//       <Tooltip title={val}>
//         <div>{val}</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "version",
//     grow: 0.5,
//     label: (
//       <Tooltip title="Version">
//         <div>Version</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "correlationId",
//     grow: 0.5,
//     label: (
//       <Tooltip title="Correlation ID">
//         <div>Correlation ID</div>
//       </Tooltip>
//     ),
//     renderer: (val) => (
//       <Tooltip title={val}>
//         <div>{val}</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "updateTime",
//     type: "date",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Update Time">
//         <div>Update Time</div>
//       </Tooltip>
//     ),
//     renderer: (val) => (
//       <Tooltip title={val}>
//         <div>{val}</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "endTime",
//     type: "date",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="End Time">
//         <div>End Time</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "status",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Status">
//         <div>Status</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "input",
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Input">
//         <div>Input</div>
//       </Tooltip>
//     ),
//     type: "json",
//     sortable: false,
//     renderer: (val) => {
//       return (
//         <Tooltip title={JSON.stringify(val)}>
//           <div>{JSON.stringify(val)}</div>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     name: "output",
//     type: "json",
//     sortable: false,
//     grow: 2,
//     wrap: false,
//     label: (
//       <Tooltip title="Output">
//         <div>Output</div>
//       </Tooltip>
//     ),
//     renderer: (val) => {
//       return (
//         <Tooltip title={val}>
//           <div>{val}</div>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     name: "reasonForIncompletion",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Reason For Incompletion">
//         <div>Reason For Incompletion</div>
//       </Tooltip>
//     ),
//     renderer: (val) => (
//       <Tooltip title={val}>
//         <div>{val}</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "executionTime",
//     label: (
//       <Tooltip title="Execution Time">
//         <div>Execution Time</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "event",
//     wrap: false,
//     label: (
//       <Tooltip title="Event">
//         <div>Event</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "failedReferenceTaskNames",
//     grow: 0.5,
//     sortable: false,
//     wrap: false,
//     label: (
//       <Tooltip title="Failed Reference Task Names">
//         <div>Failed Reference Task Names</div>
//       </Tooltip>
//     ),
//     renderer: (val) => (
//       <Tooltip title={val}>
//         <div>{val}</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "externalInputPayloadStoragePath",
//     sortable: false,
//     grow: 1,
//     wrap: false,
//     label: (
//       <Tooltip title="External Input Payload Storage Path">
//         <div>External Input Payload Storage Path</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "externalOutputPayloadStoragePath",
//     sortable: false,
//     grow: 1,
//     wrap: false,
//     label: (
//       <Tooltip title="External Output Payload Storage Path">
//         <div>External Output Payload Storage Path</div>
//       </Tooltip>
//     ),
//   },
//   {
//     name: "priority",
//     sortable: false,
//     grow: 0.5,
//     wrap: false,
//     label: (
//       <Tooltip title="Priority">
//         <div>Priority</div>
//       </Tooltip>
//     ),
//   },
// ];

// function ShowMore({
//   rowsPerPage,
//   rowCount,
//   onChangePage,
//   onChangeRowsPerPage,
//   currentPage,
// }) {
//   return (
//     <div style={{ textAlign: "center", padding: 15 }}>
//       <TertiaryButton onClick={() => onChangePage(currentPage + 1)}>
//         Show More Results
//       </TertiaryButton>
//     </div>
//   );
// }

// export default function ResultsTable({
//   resultObj,
//   error,
//   busy,
//   page,
//   rowsPerPage,
//   sort,
//   setPage,
//   setSort,
//   setRowsPerPage,
//   showMore,
// }) {
//   const classes = useStyles();
//   let totalHits = 0;
//   if (resultObj) {
//     if (resultObj.totalHits) {
//       totalHits = resultObj.totalHits;
//     } else {
//       if (resultObj.results) {
//         totalHits = resultObj.results.length;
//       }
//     }
//   }
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [toggleCleared, setToggleCleared] = useState(false);
//   const tableRef = useRef(null);

//   const defaultSortField = sort ? sort.split(":")[0] : null;
//   const defaultSortDirection = sort ? sort.split(":")[1] : null;

//   useEffect(() => {
//     setSelectedRows([]);
//     setToggleCleared((t) => !t);
//   }, [resultObj]);

//   return (
//     <Paper className={classes.paper}>
//       {busy && <LinearProgress />}
//       {error && (
//         <Alert severity="error">
//           <AlertTitle>Query Failed</AlertTitle>
//           {error.message}
//         </Alert>
//       )}
//       {!resultObj && !error && (
//         <Text className={classes.clickSearch}>
//           Click "Search" to submit query.
//         </Text>
//       )}
//       {resultObj && (
//         <DataTable
//           title={totalHits > 0 && ` Page ${page} of ${totalHits}`}
//           data={resultObj.results}
//           columns={executionFields}
//           defaultShowColumns={[
//             "startTime",
//             "workflowType",
//             "workflowId",
//             "endTime",
//             "status",
//           ]}
//           localStorageKey="executionsTable"
//           keyField="workflowId"
//           paginationServer
//           paginationTotalRows={totalHits}
//           paginationDefaultPage={page}
//           paginationPerPage={rowsPerPage}
//           onChangeRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
//           onChangePage={(page) => setPage(page)}
//           sortServer
//           defaultSortField={defaultSortField}
//           defaultSortAsc={defaultSortDirection === "ASC"}
//           onSort={(column, sortDirection) => {
//             setSort(column.id, sortDirection);
//           }}
//           selectableRows
//           contextComponent={
//             <BulkActionModule
//               selectedRows={selectedRows}
//               popperAnchorEl={tableRef.current}
//             />
//           }
//           onSelectedRowsChange={({ selectedRows }) =>
//             setSelectedRows(selectedRows)
//           }
//           clearSelectedRows={toggleCleared}
//           customStyles={{
//             ...dataTableStyles,
//             head: {
//               style: {
//                 overflow: "visible",
//                 ...dataTableStyles.head,
//               },
//             },
//             header: {
//               style: {
//                 overflow: "visible",
//                 ...dataTableStyles.header,
//               },
//             },
//             contextMenu: {
//               style: {
//                 display: "none",
//               },
//               activeStyle: {
//                 display: "flex",
//               },
//             },
//           }}
//           paginationComponent={showMore ? ShowMore : null}
//           fixedHeader
//           fixedHeaderScrollHeight="450px"
//         />
//       )}
//     </Paper>
//   );
// }
